import TextAlign from "@tiptap/extension-text-align";
import Typography from "@tiptap/extension-typography";
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import StarterKit from "@tiptap/starter-kit";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  MenuSelectTextAlign,
  RichTextEditor,
  type RichTextEditorRef,
} from "mui-tiptap";
import React from "react";
import { Ref } from "react";

interface TextEditorProps {
  content: string;
  handleChange?: any;
  editable?: boolean;
}
const TextEditor = React.forwardRef((props: TextEditorProps, ref: Ref<RichTextEditorRef>) => {
  const { content, handleChange, editable = false } = props;

  return (
    <div>
      <RichTextEditor
        editable={editable}
        ref={ref}
        onUpdate={handleChange}
        extensions={[StarterKit, Typography, TextAlign.configure({types: ['heading', 'paragraph']})]}
        content={content}
        renderControls={() => (
          <MenuControlsContainer>
            <MenuSelectHeading />
            <MenuDivider />
            <MenuButtonBold />
            <MenuButtonItalic />
            <MenuSelectTextAlign
              aria-label="Alinhamento do Texto"
              tooltipTitle="Alterar o alinhamento"
              options={[
                {
                  value: "left",
                  label: "Text-align left",
                  shortcutKeys: ["mod", "Shift", "L"],
                  IconComponent: FormatAlignLeftIcon,
                },
                {
                  value: "right",
                  label: "Text-align right",
                  shortcutKeys: ["mod", "Shift", "R"],
                  IconComponent: FormatAlignRightIcon,
                },
                {
                  value: "center",
                  label: "Text-align center",
                  shortcutKeys: ["mod", "Shift", "C"],
                  IconComponent: FormatAlignCenterIcon,
                },
                {
                  value: "justify",
                  label: "Text-align justify",
                  shortcutKeys: ["mod", "Shift", "J"],
                  IconComponent: FormatAlignJustifyIcon,
                },
              ]}
            />
          </MenuControlsContainer>
        )}
      />
    </div>
  );
});

export default TextEditor;